import {css} from '@emotion/react';
import styled from '@emotion/styled';

const Mark = styled.mark(
  ({theme}) => css`
    color: currentColor;
    background-color: ${theme.colors.backgroundStateSelected};
    padding: 4px 0;
  `
);

export type Props = {label: string; searchTerm: string};

export const ResultLabel = ({label, searchTerm}: Props) => {
  const markLower = searchTerm
    .toLocaleLowerCase(import.meta.env.VITE_LOCALE)
    .trim();
  const index = label
    .toLocaleLowerCase(import.meta.env.VITE_LOCALE)
    .indexOf(markLower);

  if (index === -1) return <>{label}</>;

  return (
    <>
      {label.slice(0, Math.max(0, index))}
      <Mark>{label.slice(index, index + markLower.length)}</Mark>
      {label.slice(index + markLower.length)}
    </>
  );
};
